// extracted by mini-css-extract-plugin
export default {"root":"WarningMessage-module__root"};